import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

const maxCharsValidator = (max: number): ValidatorFn =>
	(control: AbstractControl): { [key: string]: any | null} =>
		control.value  && control.value.length > max ? { maxChars: true } : null;

@Directive({
    selector: '[maxChars]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MaxCharsValidatorDirective,
            multi: true
        }
    ],
    standalone: true,
})
class MaxCharsValidatorDirective implements Validator {
	@Input('maxChars') length: number;

	validate(control: AbstractControl): { [key: string]: any | null} {
        return maxCharsValidator(this.length)(control);
    }
}

export {maxCharsValidator, MaxCharsValidatorDirective };
